const slugify = require('slugify');

const USER_AGENT = require( '../constants').USER_AGENT;

module.exports = {
    slugify: function( str ) {
        str = str.replace(/&|\//g,'-');

        return  slugify(str, {
            lower: true,
            strict: true,
            trim: true
        });
    },

    /**
     * getQueryParamByName
     */
    getQueryParamByName: function (name) {
        var regexS = '[\\?&]' + name + '=([^&#]*)';
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.search);

        return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : '';
    },
    /**
     * getDeviceType
     */
    getDeviceType: function () {

        var userAgent = navigator.userAgent;
        var device = USER_AGENT.SUPPORTED.exec( userAgent );
        var isUnsupported = USER_AGENT.UNSUPPORTED.test( userAgent );

        if ( device ) {
            return device[ 0 ].toLowerCase();
        }

        return isUnsupported ? 'unknown' : 'pc';

    }
};



// WEBPACK FOOTER //
// ./app/scripts/util/helpers.js